<p-table [value]="filteredHistoryLogsData" [paginator]="true" [rows]="rowsPerPage" [first]="first"
    [rowsPerPageOptions]="rowsPerPageOptions" [showCurrentPageReport]="true" [scrollable]="true"
    currentPageReportTemplate="{first} - {last} of {totalRecords}" sortMode="multiple"
    paginatorStyleClass="basin-display-flex basin-align-items-center basin-justify-content-end"
    styleClass="basin-table-height data-grid-component">
    <ng-template pTemplate="header">
        <tr>
            <th pSortableColumn="timestamp" scope="col">
                <span class="table-column-header basin-display-flex basin-align-items-center">
                    Date & Time
                    <p-sortIcon field="(timestamp | appDate )" />
                </span>
            </th>
            <th scope="col">
                <span class="table-column-header basin-display-flex basin-align-items-center">
                    Type
                </span>
            </th>
            <th scope="col">
                <span class="table-column-header basin-display-flex basin-align-items-center">
                    Action
                </span>
            </th>
            <th scope="col">
                <span class="table-column-header basin-display-flex basin-align-items-center">
                    Action By
                </span>
            </th>
            <th scope="col">
                <span class="table-column-header basin-display-flex basin-align-items-center">
                    Details
                </span>
            </th>
            <th scope="col" class="audit-list-value">
                <span class="table-column-header basin-display-flex basin-align-items-center">
                    Updated Value
                </span>
            </th>
            <th scope="col" class="audit-list-value">
                <span class="table-column-header basin-display-flex basin-align-items-center">
                    Previous Value
                </span>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-auditList>
        <tr>
            <td>{{auditList.timestamp | date: 'MM/dd/yyyy hh:mm:ss a'}}</td>
            <td>
                <div [ngSwitch]="auditList.entityType">
                    <p-tag *ngSwitchCase="'User'" icon="icon-vpn-key" [value]="auditList.entityType"
                        severity="secondary" />
                    <p-tag *ngSwitchCase="'License'" icon="icon-person" [value]="auditList.entityType"
                        severity="secondary" />
                    <p-tag *ngSwitchDefault icon="icon-landscape" [value]="auditList.entityType" severity="secondary" />
                </div>
            </td>
            <td>{{auditList.action}}</td>
            <td>{{auditList.userId}}</td>
            <td colspan="3">
                <ul class="audit-list-view">
                    <li *ngFor="let details of auditList?.auditDetails" class="audit-list-item">
                        <span class="audit-list-value first-column">{{details?.label}}</span>
                        <span class="audit-list-value second-column">
                            {{ details?.newValue  !== '(empty)' ? details?.newValue : '-'}}</span>
                        <span class="audit-list-value third-column">
                            {{details?.oldValue !== '(empty)' ? details?.oldValue : '-'}}</span>
                    </li>
                </ul>
            </td>
        </tr>
    </ng-template>
</p-table>